
/* ============================== src/api/queries/registrations.js ============================== */
// src/api/queries/registrations.js
/**
 * Хуки регистрации: query для списка (admin/hr), мутации создания
 * заявки, решения по заявке, публичной проверки занятости e-mail
 * (POST /registrations/check-email → { taken: boolean }, без авторизации
 * и без CSRF — префикс /registrations в CSRF_EXEMPT на клиенте).
 */
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../client";

export const REGISTRATIONS_KEY = ["registrations"];

export function useRegistrationsQuery(options = {}) {
  return useQuery({
    queryKey: REGISTRATIONS_KEY,
    queryFn: () => api.get("/registrations"),
    staleTime: 15 * 1000,
    ...options,
  });
}

export function useCreateRegistrationMutation() {
  return useMutation({
    mutationFn: (body) => api.post("/registrations", body),
  });
}

export function useCheckEmailMutation() {
  return useMutation({
    mutationFn: (email) => api.post("/registrations/check-email", { email }),
  });
}

export function useDecideRegistrationMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) =>
      api.post(`/registrations/${id}/decide`, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: REGISTRATIONS_KEY });
    },
  });
}
